import { Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import {
  CONFIGURATION_KEYS,
  ConfigurationService,
} from '@mmx/shared'
import { catchError, map, Observable, of, switchMap, take } from 'rxjs'

import {
  SendContactEditDialogComponent,
  SendContactEditDialogData,
  SendContactEditDialogResult,
} from './send-contact-edit-dialog.component'

@Injectable()
export class SendContactEditDialogService {
  constructor(
    private readonly configurationService: ConfigurationService,
    private readonly dialog: MatDialog,
  ) {}

  public open(data: SendContactEditDialogData): Observable<SendContactEditDialogResult | undefined> {
    return this.isEnabled().pipe(
      take(1),
      switchMap((enabled) => {
        if (!enabled) {
          return of({})
        }

        return this.dialog.open(SendContactEditDialogComponent, {
          width: '500px',
          panelClass: 'dialog-form',
          data,
        }).afterClosed()
      }),
    )
  }

  private isEnabled(): Observable<boolean> {
    return this.configurationService.index([
      CONFIGURATION_KEYS.MESSAGING_ALLOW_MANUAL_SEND_CONTACT_EDIT,
    ]).pipe(
      map((configurations) => {
        return configurations[CONFIGURATION_KEYS.MESSAGING_ALLOW_MANUAL_SEND_CONTACT_EDIT] ?? false
      }),
      catchError(() => of(false)),
    )
  }
}
